import React from "react";
import { Alerta, Box, CampoEstatico, TipoAlerta, TipoCampoEstatico } from "@intechprev/componentes-web";
import { ContratoEntidade } from "../../../../entidades";

interface IProps {
  detalhes: ContratoEntidade;
}

export const Dados: React.FC<IProps> = ({ detalhes }) => {
  return (
    <>
      {detalhes && (
        <Box titulo={"Dados do Empréstimo"}>
          <CampoEstatico
            valor={`${detalhes.NUM_CONTRATO}/${detalhes.ANO_CONTRATO}`}
            titulo={"Contrato"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.NOME_PENSIONISTA ? detalhes.NOME_PENSIONISTA : detalhes.NOME_PARTICIPANTE}
            titulo={"Nome"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.CPF_PENSIONISTA ? detalhes.CPF_PENSIONISTA : detalhes.CPF_PARTICIPANTE}
            titulo={"CPF"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.DS_PLANO}
            titulo={"Plano"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.DS_SITUACAO}
            titulo={"Situação"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.DS_MODAL}
            titulo={"Modalidade"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.DS_NATUR}
            titulo={"Natureza"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.PRAZO}
            titulo={"Prazo"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.DT_SOLICITACAO}
            titulo={"Solicitado em"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.DT_CREDITO}
            titulo={"Data de Crédito"}
            tamanhoTitulo={"5"}
          />

          <CampoEstatico
            valor={detalhes.VL_SOLICITADO}
            titulo={"Valor Solicitado"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={detalhes.VL_PRESTACAO}
            titulo={"Valor Prestação"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={detalhes.VL_IOF}
            titulo={"IOF"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={detalhes.VL_TX_ADM}
            titulo={"Taxa ADM"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={detalhes.VL_TX_INAD}
            titulo={"Taxa Garantia"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={detalhes.VL_REFORMADO}
            titulo={"Valor Reformado"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={detalhes.VL_LIQUIDO}
            titulo={"Valor Líquido"}
            tamanhoTitulo={"5"}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            valor={`${detalhes.NUM_BANCO}/${detalhes.NUM_AGENCIA}/${detalhes.NUM_CONTA}`}
            titulo={"Dados Bancários"}
            tamanhoTitulo={"5"}
          />

          {detalhes.CD_SITUACAO === 0 && (
            <Alerta
              tipo={TipoAlerta.info}
              mensagem={
                "Para cancelar o empréstimo, é necessário solicitar por e-mail, colocando no assunto Cancelamento do Empréstimo e o número da sua matrícula, até o dia 20 do mês do crédito do empréstimo."
              }
            />
          )}
        </Box>
      )}
    </>
  );
}